<template>
    <!--弹窗-->
    <el-dialog
        width="640px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="form" :inline="true" status-icon label-width="130px" class="query-form" size="mini">
            <el-form-item label="国家: " class="query-form-item" prop="state" label-width="165px">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="wrapBox">
            <el-form ref="formData" :model="formData" label-width="180px" size="mini">
                <div class="top">
                    <div style="font-weight: 900;">下载模板</div>
                    <div>
                        <a href="/export/SB广告组广告位模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“SB广告组广告位模板”模板</a>
                    </div>
                </div>
                <div class="download">
                    <el-upload
                        class="upload-demo"
                        drag
                        action="/"
                        accept=".xls, .xlsx"
                        ref="upload"
                        :file-list="files"
                        :http-request="handleUpload"
                        :on-exceed='handExceed'
                        :on-remove="handleRemove"
                        :auto-upload="false"
                        :limit="1"
                        multiple>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件</div>
                    </el-upload>
                </div>
            </el-form>
            <el-row class="bottomBox">
                <el-button
                    style="float:right;margin-left:6px;"
                    size="mini"
                    type="danger"
                    plain
                    @click="handleClose()"
                >取 消</el-button>
                <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')">确定</el-button>
            </el-row>
        </div>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
import { str_arr } from "@/utils/method";
export default {
    data() {
        return {
            files: [],
            disabled: false,
            formData: {},
            textarea: "",
            date: [],
            dateArr:[
                {title: '最新日期区间',val:2},
                {title: '最新日期',val:1}
            ],
            dateType: 1,
            query: {
                state: "",
            },
            rules: {
                state: [
                    {
                        required: true,
                        message: '请选择国家',
                        trigger: 'blur'
                    }
                ]
            },
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                fileList.length} 个文件.`
            });
            return;
        },
        handFileSuccess() {
            this.files = [];
            this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        // 保存信息
        submitForm() {
            this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
            if (this.files.length == 0) {
                this.$message.warning(`当前限制只能上传选择 1 个文件`);
                return;
            }
            let file = new FormData();
            console.log('file111:', this.files[0])
            file.append("file", this.files[0]);
            file.append("state", this.query.state);
            const loading = this.$loading({
                lock: true,
                text: "上传中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            api.sb_upload_source_file(file)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: `${res.data}`,
                            type: "success"
                        });
                        this.disabled = false;
                        this.handleClose(true);
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                })
                .finally(() => {
                    loading.close();
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.files = []
            this.query.state = ''
            this.formData = {};
            this.dateType = 1
            this.textarea = "";
            this.date = [];
            this.$emit("close-callback", isshow);
            this.disabled = false;
        }
    }
};
</script>
<style type="text/scss" lang="scss">
    .wrapBox {
        width: 600px;
        margin-top: 10px;
        .bottomBox {
            margin-top:17px;
            display: flex;
            justify-content: center;
        }
    }
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>
